import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, associateOnly = false }) {
  const { user, checked } = useAuth();
  if (!checked) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        Carregando...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // Só bloqueia enquanto o comprovante ainda não foi enviado.
  // Depois de enviar (pending_review), permite o acesso — mas o admin ainda precisa liberar.
  if (user.activation_status === "awaiting_payment") {
    return <Navigate to="/aguardando-ativacao" replace />;
  }
  if (associateOnly && user.account_type === "buyer") return <Navigate to="/dashboard" replace />;
  return children;
}
